import { createContext } from 'react';
import AppContext from 'types/contexts/AppContext';

export default createContext({} as AppContext);
